import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import sharedStyle from 'app/components/DesignVersion/Grad/Blocks/PlayersHeadToHeadBlockGrad/style.module.scss';
import StatValue from 'app/components/StatValue';
import { roundForDisplay } from 'app/utils/number';
import CSWeapon from 'app/components/CSWeapon';

import style from './style.module.scss';

const NUMBER_OF_WEAPONS_DISPLAYED = 4;

interface Props {
  playerTeam1: StatPlayerCs | undefined;
  playerTeam2: StatPlayerCs | undefined;
}

const CsPlayersWeaponsStats: FC<Props> = ({ playerTeam1, playerTeam2 }) => {
  const { t } = useTranslation();

  const playerTeam1Weapons = (playerTeam1?.weapons_with_highest_average_kills_per_game || []).slice(
    0,
    NUMBER_OF_WEAPONS_DISPLAYED
  );
  const playerTeam2Weapons = (playerTeam2?.weapons_with_highest_average_kills_per_game || []).slice(
    0,
    NUMBER_OF_WEAPONS_DISPLAYED
  );

  return (
    <div className={sharedStyle.videogameSpecificStatsTables}>
      {[playerTeam1Weapons, playerTeam2Weapons].map((playerWeapons, index) => (
        <div
          className={classNames(sharedStyle.videogameSpecificStatsTable, style.csWeaponsTable)}
          key={index}
        >
          <div
            className={classNames(
              sharedStyle.videogameSpecificStatsTableHeader,
              style.csWeaponsHeader
            )}
          >
            <div>{t('block-players_head_to_head-cs-weapons')}</div>
            <div>{t('block-players_head_to_head-cs-kills')}</div>
          </div>
          {playerWeapons.length === 0 ? (
            <div className={sharedStyle.videogameSpecificStatsTableNoContent}>
              {t('error_no-data_compact')}
            </div>
          ) : (
            <div className={sharedStyle.videogameSpecificStatsTableContent}>
              {playerWeapons.map(weaponStat => (
                <div key={weaponStat.weapon.id} className={style.csWeaponsLine}>
                  <div className={style.csWeaponsNameColumn}>{weaponStat.weapon.name}</div>
                  <div>
                    <CSWeapon id={weaponStat.weapon.id} className={style.csWeapon} />
                  </div>
                  <div className={style.csStatsColumn}>
                    <StatValue
                      value={weaponStat.average_kills_per_game}
                      displayFunction={roundForDisplay(2)}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

CsPlayersWeaponsStats.displayName = 'CsPlayersWeaponsStats';

export default CsPlayersWeaponsStats;
